import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Requisites() {
  const [data, setData] = useState(null);

  useEffect(() => {
    document.title = "Реквизиты — vip77.store";
    api.get("/settings").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const rows = [
    ["Полное наименование", data?.legal_entity_name],
    ["ИНН", data?.legal_inn],
    ["ОГРН", data?.legal_ogrn],
    ["Юридический адрес", data?.legal_address],
    ["Электронная почта", "support@vip77.store"],
  ];
  const hasAny = rows.some(([, value]) => value);

  return (
    <div data-testid="requisites-page" className="mx-auto max-w-3xl px-4 py-16 lg:px-8">
      <div className="text-[11px] font-bold uppercase tracking-[0.24em] text-muted-soft">Документы</div>
      <h1 className="mt-2 text-4xl font-extrabold tracking-tightest text-ink">Реквизиты интернет-магазина vip77.store</h1>
      {data && !hasAny ? (
        <p className="mt-8 text-sm text-muted">Реквизиты уточняются.</p>
      ) : (
        <div className="mt-8 divide-y divide-line rounded-2xl border border-line bg-white">
          {rows.filter(([, value]) => value).map(([label, value]) => (
            <div key={label} className="flex flex-col gap-1 px-6 py-4 sm:flex-row sm:items-baseline sm:justify-between">
              <span className="text-xs font-semibold uppercase tracking-[0.12em] text-muted-soft">{label}</span>
              <span className="text-sm font-medium text-ink">{value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
